"use strict";

define('components/dom_setup',['components/utils'], function(utils) {
    /* This function contains code to run when the DOM is modified. Typically
       this is used in toggling between edit and read-only views, although
       it could be used elsewhere too. It handles things such as setting up
       bootstrap popovers.

       Note that initialization specific to forms or other components
       is best located in those components. This is only for site-wide
       setup activities. */

    var domSetup = {

        init: function(node) {
            node.find('a[data-toggle=popover], button[data-toggle=popover], span[data-toggle=popover]').each(function(){
                $(this).popover().click(function(e) {
                    // Need to prevent the default click action since popovers are on focus.
                    e.stopPropagation();
                    e.preventDefault();
                });
            });

            utils.init(node);

            var tableFilterBarNode = node.find('.buttonbar[data-filter-bar-type="table_filter_bar"]');
            if (tableFilterBarNode[0]) {
                require(['components/filter_bar/table_filter_bar'], function(tableFilterBarComponent) {
                    tableFilterBarComponent.init(node);
                });
            }

            var tables = node.find('table.table.biglist');
            if (tables[0]) {
                require(['components/table'], function(Table) {
                    tables.each(function() {
                        var tableInstance = new Table();
                        var tableParent = $(this).parent();
                        var tableContainer = tableParent.closest('.table');
                        tableInstance.init(tableContainer[0] ? tableContainer : tableParent);
                    });
                });
            }

            node.find('.fade-out').delay(2 * 1000).fadeOut(2 * 1000);

            node.find('.popover a').click(function(e) {
                e.stopPropagation();
            });

            if (node.find('.edit-link').length > 0) {
                require(['components/editable_module'], function(editableModule) {
                    editableModule.init(node);
                });
            }

            if (node.find('.chart_container').length > 0) {
                require(['components/charts'], function(charts) {
                    charts.init(node);
                });
            }

            if (node.find('.photo-carousel').length > 0) {
                require(['components/carousel'], function(carousel) {
                    carousel.init(node);
                });
            }

            if (node.find('.map-container').length > 0) {
                require(['components/maps'], function(maps) {
                    maps.init();
                });
            }

            if (node.find('.modal, .nda-block').length > 0) {
                require(['components/modal'], function(modal) {
                    modal.init(node)
                })
            }

            // Get all forms except '.navbar-form', which is the search form in the header.
            // Also, `node` may potentially itself be a form.
            // For each relevant form, call `form.init()`.
            var forms = node.find('form').andSelf().filter('form').not('.navbar-form');
            require(['components/form', 'components/form_manager'], function(form, formManager) {
                forms.each(function() {
                    var formNode = $(this);
                    form.init(formNode);

                    if (formNode.is('.manage-submit')) {
                        formManager.init(formNode);
                    }
                });
            });

            // Initialize any select2 components that appear outside of forms
            if (node.find('.select2').length > 0) {
                require(['select2'], function() {
                    node.find('.select2').each(function() {
                        if ($(this).closest('form').length == 0) {
                           $(this).select2();
                        }
                    });
                });
            }

            if (node.find('#tasks-module').length > 0) {
                require(['components/tasks'], function(tasks) {
                    tasks.init(node.find('#tasks-module'));
                });
            }

            // Initialize task list on dashboard after adding the task. Otherwise
            // list won't get rerendered.
            if (node.find('#your-tasks-content').length > 0) {
                require(['components/tasks'], function(tasks) {
                    tasks.init(node);
                });
            }

            // Load any new-style components
            var jsqCmps = node.find('.jsq-cmp');
            if (node.hasClass('jsq-cmp')) {
                jsqCmps = jsqCmps.add(node);
            }
            jsqCmps.each(function() {
                var componentNode = $(this);
                var componentName = componentNode.data('cmp');
                if (componentName && componentName !== 'editor') {
                    require(['components/' + componentName], function(component) {
                        component.init(componentNode);
                    });
                }
            });
        }
    };

    return domSetup;
});

